"use client"

import { UserService } from '@repo/ui/lib/api/services/user.service';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const currentUserQueryKey = ['users', 'me'] as const;

export function useGetCurrentUser(
  options?: UseQueryOptions<any, Error, any, typeof currentUserQueryKey>
) {
  return useQuery({
    queryKey: currentUserQueryKey,
    queryFn: async () => {
      const service = new UserService();
      return service.getUserProfile();
    },
    staleTime: 0,
    ...options
  });
}


